/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/technology': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm8 11v1h-3v3h-3v3h-1v-3H9v3H8v-3H5v-3H2v-1h3V9H2V8h3V5h3V2h1v3h2V2h1v3h3v3h3v1h-3v2h3z"/><path pid="1" d="M13 13H7V7h6v6zm-5-1h4V8H8v4z"/>'
  }
})
